
import { constructionAdvisorStages, constructionApplicantStages } from './construction/construction';
import { adminOnlyStageConfigs, loOnlyStageConfig, applicantStages, loStageConfigs, rateApproverStageConfigs } from './consumer/consumer';
import { loStageDepositConfigs } from './dda/deposit';
import { STAR_BANK_NAMESPACE_ID } from "src/constants";
import { BUSINESS_ACCOUNT, CONSUMER_ACCOUNT, DEPOSIT_ACCOUNTS, HOME_EQUITY, MERCHANTCASHADVANCES, PURCHASE, REFINANCE, RESIDENTIAL_MORTGAGE, SMALL_BUSINESS_LOAN } from "src/features/LoansHome/Products/constants";
import { APPLICANT, SMARTMATCH_TYPE_ADMIN, SMARTMATCH_TYPE_LOAN_ASSISTANT, SMARTMATCH_TYPE_LOAN_OFFICER, SMARTMATCH_TYPE_LOAN_PROCESSOR } from "src/services/constants";
import {  
    mkApplicantLoanStagesForDeposit, 
    mkAdvisorLoanStagesForFundloan, 
    mkApplicantLoanStagesForFundloan,
    mkResidentialMortgageStageforAdmin,
    mkResidentialMortgageStageforLO,
    mkResidentialMortgageApplicantStage
} from "./loanStatus";


const STAR_APPLICANT_DEPOSIT_LOAN_STAGES_CONFIG = {
    id: '154878745215745754',
    namespace_id: STAR_BANK_NAMESPACE_ID,
    loan_type: [DEPOSIT_ACCOUNTS],
    sub_loan_types: [BUSINESS_ACCOUNT, CONSUMER_ACCOUNT],
    stages: mkApplicantLoanStagesForDeposit,
    roles: [
        APPLICANT
    ],
};

const STAR_ADVISOR_FUNDALOAN_LOAN_STAGES_CONFIG = {
    id: '154878745215745754',
    namespace_id: STAR_BANK_NAMESPACE_ID,
    loan_type: [MERCHANTCASHADVANCES],
    sub_loan_types: [SMALL_BUSINESS_LOAN],
    stages: mkAdvisorLoanStagesForFundloan,
    roles: [
        SMARTMATCH_TYPE_ADMIN,
        SMARTMATCH_TYPE_LOAN_OFFICER,
        SMARTMATCH_TYPE_LOAN_PROCESSOR,
        SMARTMATCH_TYPE_LOAN_ASSISTANT

    ],
};

const STAR_APPLICANT_FUNDALOAN_LOAN_STAGES_CONFIG = {
    id: '154878745215745754',
    namespace_id: STAR_BANK_NAMESPACE_ID,
    loan_type: [MERCHANTCASHADVANCES],
    sub_loan_types: [SMALL_BUSINESS_LOAN],
    stages: mkApplicantLoanStagesForFundloan,
    roles: [APPLICANT],
};

const STAR_RESIDENTIAL_MORTGAGE_LOAN_STAGES_CONFIG_ADMIN = {
    id: '154878745215745754',
    namespace_id: STAR_BANK_NAMESPACE_ID,
    loan_type: [RESIDENTIAL_MORTGAGE],
    sub_loan_types: [PURCHASE, REFINANCE,HOME_EQUITY],
    stages: mkResidentialMortgageStageforAdmin,
    roles: [
        SMARTMATCH_TYPE_ADMIN,
        SMARTMATCH_TYPE_LOAN_PROCESSOR,
    ],
};


const STAR_RESIDENTIAL_MORTGAGE_LOAN_STAGES_CONFIG_LOAN_OFFICER = {
    id: '154878745215745754',
    namespace_id: STAR_BANK_NAMESPACE_ID,
    loan_type: [RESIDENTIAL_MORTGAGE],
    sub_loan_types: [PURCHASE, REFINANCE,HOME_EQUITY],
    stages: mkResidentialMortgageStageforLO,
    roles: [
        SMARTMATCH_TYPE_LOAN_OFFICER,
        SMARTMATCH_TYPE_LOAN_ASSISTANT
    ],
};

const STAR_LOAN_STAGES_CONFIG_APPLICANT = {
    id: '154878745215745754',
    namespace_id: STAR_BANK_NAMESPACE_ID,
    loan_type: [RESIDENTIAL_MORTGAGE],
    sub_loan_types: [PURCHASE, REFINANCE,HOME_EQUITY],
    stages: mkResidentialMortgageApplicantStage,
    roles: [APPLICANT],
};


export const starBankLoanStages = [
    loStageConfigs,
    applicantStages,
    rateApproverStageConfigs,
    loStageDepositConfigs,
    adminOnlyStageConfigs,
    loOnlyStageConfig,
    constructionApplicantStages,
    constructionAdvisorStages,
    STAR_LOAN_STAGES_CONFIG_APPLICANT,
    STAR_RESIDENTIAL_MORTGAGE_LOAN_STAGES_CONFIG_ADMIN,
    STAR_RESIDENTIAL_MORTGAGE_LOAN_STAGES_CONFIG_LOAN_OFFICER,
    STAR_APPLICANT_FUNDALOAN_LOAN_STAGES_CONFIG,
    STAR_ADVISOR_FUNDALOAN_LOAN_STAGES_CONFIG,
    STAR_APPLICANT_DEPOSIT_LOAN_STAGES_CONFIG
]